const exemptRoutes = [
  '/auth',
  '/home',
  '/admin',
  '/join',
  '/api',
  '/_next',
  '/images',
  '/assets',
  '/locales',
  '/landing-pages',
  '/.well-known',
  '/payment',
  '/book/return',
  '/guests',
  '/privacy-policy',
  '/terms-of-service',
  '/cookie-policy',
  '/contact',
  '/members-only',
];

export function isProfileSetupExemptPath(pathname: string) {
  return (
    [
      '/favicon.ico',
      '/robots.txt',
      '/sitemap.xml',
      '/manifest.webmanifest',
      '/llms.txt',
    ].includes(pathname) ||
    exemptRoutes.some(
      (route) => pathname === route || pathname.startsWith(`${route}/`),
    )
  );
}
